<template>
  <div>
    <modal-provider :fullscreen-breakpoint="601" name="geo-modal" @before-open="beforeOpen">
      <template v-slot:modal-heading>
        <h2 class="modal__title">
          {{ $t('select_your_city') }}
        </h2>
        <span class="modal__subtitle">{{ $t('deliver_everywhere') }}</span>
      </template>
      <div class="geo-modal__detect-geo" @click="detectUserCity">
        <svg width="30"
             height="30"
             viewBox="0 0 30 30"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="15"
                   cy="25.8889"
                   rx="11"
                   ry="3.11111"
                   fill="#E7E7E7" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9588 25.5748C15.9588 25.5748 24.9832 18.4064 24.9832 10.6662C24.9832 5.32771 20.5136 1 15 1C9.48651 1 5.0169 5.32771 5.0168 10.6662C5.0168 18.4064 14.0412 25.5748 14.0412 25.5748C14.5685 25.9936 15.4315 25.9936 15.9588 25.5748ZM14.9997 16.1803C18.0145 16.1803 20.4585 13.8153 20.4585 10.8979C20.4585 7.98055 18.0145 5.61556 14.9997 5.61556C11.9849 5.61556 9.54088 7.98055 9.54088 10.8979C9.54088 13.8153 11.9849 16.1803 14.9997 16.1803Z"
            fill="#E7E7E7"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9315 25.5815C15.9315 25.5815 24.7714 18.5639 24.7714 10.9866C24.7714 5.76034 20.3931 1.52365 14.9924 1.52365C9.59159 1.52365 5.21339 5.76034 5.21329 10.9866C5.21329 18.5639 14.0531 25.5815 14.0531 25.5815C14.5697 25.9916 15.415 25.9916 15.9315 25.5815ZM14.9997 16.1803C18.0146 16.1803 20.4585 13.8153 20.4585 10.8979C20.4585 7.98055 18.0146 5.61556 14.9997 5.61556C11.9849 5.61556 9.54095 7.98055 9.54095 10.8979C9.54095 13.8153 11.9849 16.1803 14.9997 16.1803Z"
            fill="#909090"
          />
        </svg>
        <button class="link link--pseudo">
          {{ $t('detect_my_location') }}
        </button>
      </div>
      <GeoSelectCity geo-modal />
      <ul class="geo-modal__city-list" v-if="popularCities">
        <li class="geo-modal__city-list-item" v-for="city in popularCities" :key="city.id">
          <button
            class="geo-modal__city-list-btn"
            :class="{
              'geo-modal__city-list-btn--selected': city.id === selectedUserLocation.city_id
            }"
            @click="sendCity(city)"
          >
            {{ city.name[currLocale] }}
          </button>
        </li>
      </ul>
    </modal-provider>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import axios from 'axios'
import GeoSelectCity from '@/components/user-geo/GeoSelectCity'

export default {
  name: 'GeoModal',
  components: {
    GeoSelectCity
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'userGeoFromCookies']),
    ...mapState({
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      exactUserLocation: state => state.geoLocation.exactUserLocation,
      popularCities: state => state.geoLocation.popularCities,
      currLocale: state => state.translation.language
    })
  },
  methods: {
    ...mapActions(['FETCH_DELIVERY_CITIES', 'SEND_USER_CITY', 'SET_SELECTED_USER_GEO_ACTION']),
    beforeOpen () {
      if (!this.popularCities) {
        // eslint-disable-next-line no-return-assign
        this.FETCH_DELIVERY_CITIES().then(response => this.$store.commit('SET_POPULAR_CITIES', response.cities))
      }
    },
    hideModal ({ target }) {
      if (target.className === 'v--modal-background-click') {
        this.$modal.hide('geo-modal')
      }
    },
    detectUserCity () {
      if (this.exactUserLocation) {
        const { latitude, longitude } = this.exactUserLocation

        axios
          .get(this.urlLanguagePrefix + '/location/', {
            params: { latitude, longitude }
          })
          .then(response => {
            if (response.data && response.data.city_list && response.data.city_list.length) {
              this.sendCity(response.data.city_list[0])
            }
          })
      } else {
        this.SET_SELECTED_USER_GEO_ACTION(this.userGeoFromCookies)
      }
    },
    sendCity (city) {
      this.SEND_USER_CITY(city.id || city.city_id)
      this.$modal.hide('geo-modal')
    }
  }
}
</script>

<style lang="sass">

.geo-modal__city-list
  +list-unstyled
  padding: 0
  margin-top: 30px
  display: flex
  justify-content: space-between
  flex-wrap: wrap

.geo-modal__city-list-item
  list-style: none
  width: 50%

  +mmin($small)
    width: 33%

.geo-modal__city-list-item:not(:last-child)
  margin-bottom: 10px

.geo-modal__city-list-btn
  border: 0
  background: transparent
  color: $text-color
  padding: 5px 15px
  border-radius: 3px
  text-align: left
  font-family: 'Cera Pro', Roboto, Helvetica, Arial, sans-serif

  &--selected
    background: $nd-disabled-background-color

  &:hover
    color: $main-color

.geo-modal__detect-geo
  display: flex
  align-items: center
  margin: 0 0 20px 20px

  .link
    background-color: transparent
    margin-left: 10px
</style>
